import { useMemo } from 'react';
import { useAppSelector } from '../../hooks';
import { PrivilegesWithFeatureFlags, calculatePrivileges } from './privileges';

const useAccessControl = (): PrivilegesWithFeatureFlags => {
  const userToken = useAppSelector((state) => state.user.idToken);
  const featureFlags = useAppSelector((state) => state.featureFlags.flags);
  const privileges = useMemo(
    () => calculatePrivileges(userToken, featureFlags),
    [userToken, featureFlags]
  );

  return privileges;
};

export default useAccessControl;
